import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
@Injectable()
export class SharedService {
  private emitChangeSource = new Subject<any>();
  private emitSupportChange = new Subject<any>();
  private emitAlert = new Subject<any>();
  private emitUnautorizedVal = new Subject<any>();
  private emitRevisionCost = new Subject<any>();
  changeEmitted$ = this.emitChangeSource.asObservable();
  supportEmitted$ = this.emitSupportChange.asObservable();
  alertEmitted$ = this.emitAlert.asObservable();
  unautorizedEmitted$ = this.emitUnautorizedVal.asObservable();
  costEmitted$ = this.emitRevisionCost.asObservable();

  emitLogin(returnUrl: any) {
    this.emitChangeSource.next(returnUrl);
  }

  emitHome() {
    this.emitChangeSource.next('home');
  }

  emitSupport() {
    this.emitSupportChange.next('');
  }

  emitAlertMessage(message) {
    this.emitAlert.next(message);
  }

  emitUnautorized() {
    this.emitUnautorizedVal.next('');
  }

  emitNewCost(cost) {
    this.emitRevisionCost.next(cost);
  }
}
